import { ArrowBackIosRounded } from '@mui/icons-material';
import { IconButton, Paper, Stack, Typography } from '@mui/material';

interface UserQuotesFooterProps {
  currentQuoteNumber: number;
  proofCount: number;
  onNextClick: () => void;
  onPreviousClick: () => void;
}

export function UserQuotesFooter({
  currentQuoteNumber,
  proofCount,
  onNextClick,
  onPreviousClick,
}: UserQuotesFooterProps) {
  return (
    <Stack
      component={Paper}
      elevation={2}
      direction="row"
      spacing={1.5}
      alignItems="center"
      sx={{ py: 1.5, pl: 2 }}
    >
      <IconButton
        color="primary"
        size="small"
        disabled={currentQuoteNumber === 1}
        onClick={onPreviousClick}
      >
        <ArrowBackIosRounded fontSize="inherit" />
      </IconButton>
      <Typography variant="body1">
        {currentQuoteNumber} of {proofCount}
      </Typography>
      <IconButton
        color="primary"
        size="small"
        disabled={currentQuoteNumber === proofCount}
        onClick={onNextClick}
      >
        <ArrowBackIosRounded
          fontSize="inherit"
          sx={{ transform: 'rotate(-180deg)' }}
        />
      </IconButton>
    </Stack>
  );
}
